export default "__VITE_ASSET__K84kqEz8__"